(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["featured-tabs"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('product-tabs')) {
    customElements.define('product-tabs', class extends HTMLElement {
      connectedCallback() {
        this.tabs = Array.from(this.querySelectorAll('.pdp-tabs__tab'));
        this.panels = Array.from(this.querySelectorAll('.pdp-tabs__panel'));
        this.tabs.forEach((tab) => {
          tab.addEventListener('click', () => this.activate(tab.dataset.index));
        });
      }
      activate(index) {
        this.tabs.forEach((t) => {
          const on = t.dataset.index === index;
          t.classList.toggle('is-active', on);
          t.setAttribute('aria-selected', on ? 'true' : 'false');
        });
        this.panels.forEach((p) => {
          p.classList.toggle('is-active', p.dataset.index === index);
        });
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
